import { render, staticRenderFns } from "./CircledPlus.vue?vue&type=template&id=b4b68a5a&"
import script from "./CircledPlus.vue?vue&type=script&lang=js&"
export * from "./CircledPlus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports